export default {"src":"/_next/static/image/public/images/ic_location_black.043f393650691fc8bad13fc3efcc8603.svg","height":17,"width":15};